import { Cookie, KeyRound } from 'lucide-react';
import { CrawlAuthModeToggle } from './CrawlAuthModeToggle';
import { CrawlCookieFields } from './CrawlCookieFields';
import { CrawlCredentialFields } from './CrawlCredentialFields';
import { CrawlGoogleFields } from './CrawlGoogleFields';

function CrawlAuthHint({ authMode }) {
  if (authMode === 'google') {
    return (
      <div className="flex items-center gap-2 text-xs text-zinc-500">
        <KeyRound className="h-3 w-3" />
        <span>Connexion Google automatisée pour sites tiers et pages Google protégées</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-xs text-zinc-500">
      <Cookie className="h-3 w-3" />
      <span>Bascule entre identifiants simples, cookies de session et Google</span>
    </div>
  );
}

export function CrawlAuthSection(props) {
  return (
    <div className="space-y-4 rounded-sm border border-zinc-800 bg-zinc-900/30 p-4">
      <p className="text-xs text-muted-foreground">Authentification optionnelle pour les sites protégés</p>
      <CrawlAuthHint authMode={props.authMode} />

      <CrawlAuthModeToggle
        authMode={props.authMode}
        setAuthMode={props.setAuthMode}
        crawling={props.crawling}
      />

      {props.authMode === 'cookies' ? (
        <CrawlCookieFields
          sessionCookies={props.sessionCookies}
          setSessionCookies={props.setSessionCookies}
          showCookieHelp={props.showCookieHelp}
          setShowCookieHelp={props.setShowCookieHelp}
          crawling={props.crawling}
        />
      ) : null}

      {props.authMode === 'credentials' ? (
        <CrawlCredentialFields
          username={props.username}
          setUsername={props.setUsername}
          password={props.password}
          setPassword={props.setPassword}
          crawling={props.crawling}
        />
      ) : null}

      {props.authMode === 'google' ? (
        <CrawlGoogleFields
          googleEmail={props.googleEmail}
          setGoogleEmail={props.setGoogleEmail}
          googlePassword={props.googlePassword}
          setGooglePassword={props.setGooglePassword}
          rememberGoogleSession={props.rememberGoogleSession}
          setRememberGoogleSession={props.setRememberGoogleSession}
          useSavedGoogleSession={props.useSavedGoogleSession}
          setUseSavedGoogleSession={props.setUseSavedGoogleSession}
          crawling={props.crawling}
        />
      ) : null}
    </div>
  );
}
